import React from 'react';
import { DatePickerInput } from '../shared/DatePickerInput';

const DatePickerInputField = ({ field, form, value, ...restProps }) => {
  const handleChange = (val) => {
    form.setFieldTouched(field.name, true);
    form.setFieldValue(field.name, val);
  };

  return (
    <DatePickerInput
      {...field}
      {...restProps}
      onChange={restProps.onChange || handleChange}
    />
  );
};

export default React.memo(DatePickerInputField);
